function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707473;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M121.81,130.15V35.42A8.45,8.45,0,0,0,113.39,27H59.32a8.44,8.44,0,0,0-8.41,8.42v13H33.72A12.32,12.32,0,0,0,21.39,60.79v9.48A12.32,12.32,0,0,0,33.72,82.6H49.6l1.31,1.31v46.36a8.44,8.44,0,0,0,8.41,8.41h54.07A8.33,8.33,0,0,0,121.81,130.15Zm-66.28.12v-7.71h61.53v7.71a3.69,3.69,0,0,1-3.67,3.67H59.32A3.88,3.88,0,0,1,55.53,130.27ZM89.44,89.36H88a11.26,11.26,0,1,1,1.42,0ZM89.2,94.1c12.45.24,22.41,10.68,22.88,23.72H65.37c.48-12.93,10.55-23.48,22.88-23.72h1ZM33.6,53H60.15a7.57,7.57,0,0,1,7.59,7.59V70a7.57,7.57,0,0,1-7.59,7.59H58.73A2.38,2.38,0,0,0,56.36,80v2.6l-1.18-1.18a1.37,1.37,0,0,0-.6-.59l-2.37-2.38a2.35,2.35,0,0,0-1.66-.71H33.6A7.56,7.56,0,0,1,26,70.16V60.67A7.75,7.75,0,0,1,33.6,53Zm21.81-4.62V44.9h61.53v72.8h-.23c-.36-12.33-8.06-22.88-18.73-26.8A15.92,15.92,0,0,0,104.61,78,16,16,0,1,0,79.24,90.9c-10.67,3.92-18.37,14.47-18.73,26.8h-5V88.53l1.54,1.54a2.34,2.34,0,0,0,1.66.72,2.21,2.21,0,0,0,1-.24,2.35,2.35,0,0,0,1.42-2.14V82.49A12.4,12.4,0,0,0,72.48,70.16V60.67A12.32,12.32,0,0,0,60.15,48.34Zm61.77-12.92v4.74H55.65V35.42a3.69,3.69,0,0,1,3.67-3.68h54.07A3.8,3.8,0,0,1,117.18,35.42ZM82.68,128a3.68,3.68,0,1,0,3.68-3.67A3.7,3.7,0,0,0,82.68,128Zm2.61,0a1.07,1.07,0,1,1,1.07,1.07A1.06,1.06,0,0,1,85.29,128Zm4.15-89.63h-6a2.37,2.37,0,0,1,0-4.74h6a2.37,2.37,0,1,1,0,4.74Z"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "44.66 72.52 44.66 67.3 39.51 67.3 39.51 63.35 44.66 63.35 44.66 58.13 48.8 58.13 48.8 63.35 53.89 63.35 53.89 67.42 48.68 67.42 48.68 72.52 44.66 72.52"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M160.79,76.66a17.56,17.56,0,0,1-7.24,1.3C145.82,78,140,73.08,140,64.08c0-8.58,5.82-14.4,14.32-14.4a14.65,14.65,0,0,1,6.51,1.22L160,53.79a12.94,12.94,0,0,0-5.53-1.14c-6.43,0-10.71,4.11-10.71,11.31,0,6.72,3.87,11,10.54,11a14.22,14.22,0,0,0,5.78-1.14Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M169.82,68.93,167,77.55h-3.66l9.32-27.42h4.27l9.36,27.42h-3.78l-2.93-8.62Zm9-2.77-2.69-7.9c-.61-1.78-1-3.41-1.43-5h-.08c-.4,1.63-.85,3.3-1.38,5l-2.68,7.94Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M213.24,65.51c-.21-3.83-.45-8.43-.41-11.84h-.12c-.94,3.21-2.08,6.63-3.46,10.41l-4.84,13.31h-2.69l-4.43-13.06c-1.31-3.87-2.4-7.41-3.18-10.66H194c-.08,3.41-.28,8-.53,12.13l-.73,11.75h-3.38l1.91-27.42h4.52l4.68,13.26c1.14,3.38,2.07,6.39,2.77,9.24h.12c.69-2.77,1.67-5.78,2.89-9.24l4.88-13.26h4.52l1.71,27.42h-3.46Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M141.46,88.49a51.5,51.5,0,0,1,7.53-.57c5.08,0,8.7,1.18,11.11,3.42s3.86,5.41,3.86,9.85-1.38,8.14-4,10.66-6.79,3.94-12.12,3.94a58.17,58.17,0,0,1-6.43-.32ZM145,112.74a21.43,21.43,0,0,0,3.58.21c7.57,0,11.68-4.23,11.68-11.64,0-6.47-3.62-10.58-11.11-10.58a20.34,20.34,0,0,0-4.15.37Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M192,101.55C192,111,186.26,116,179.26,116c-7.24,0-12.33-5.61-12.33-13.92,0-8.7,5.41-14.4,12.73-14.4,7.49,0,12.33,5.74,12.33,13.87m-21.28.45c0,5.86,3.18,11.11,8.75,11.11s8.79-5.17,8.79-11.39c0-5.46-2.85-11.15-8.75-11.15S170.71,96,170.71,102"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M215.75,114.66a17.56,17.56,0,0,1-7.24,1.3c-7.73,0-13.55-4.88-13.55-13.88,0-8.58,5.82-14.4,14.32-14.4a14.74,14.74,0,0,1,6.52,1.22l-.86,2.89a12.91,12.91,0,0,0-5.53-1.14c-6.43,0-10.71,4.11-10.71,11.31,0,6.72,3.87,11,10.54,11a14.18,14.18,0,0,0,5.78-1.14Z"
});

var _ref11 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "226.53 91.14 218.19 91.14 218.19 88.13 238.5 88.13 238.5 91.14 230.12 91.14 230.12 115.55 226.53 115.55 226.53 91.14"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M263.88,101.55c0,9.44-5.73,14.45-12.73,14.45-7.24,0-12.33-5.61-12.33-13.92,0-8.7,5.41-14.4,12.74-14.4,7.48,0,12.32,5.74,12.32,13.87M242.6,102c0,5.86,3.18,11.11,8.75,11.11s8.79-5.17,8.79-11.39c0-5.46-2.85-11.15-8.75-11.15S242.6,96,242.6,102"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M268.48,88.49a37.4,37.4,0,0,1,6.8-.57c3.78,0,6.22.7,7.93,2.24a6.84,6.84,0,0,1,2.16,5.21,7.21,7.21,0,0,1-5.17,7v.12c2.11.73,3.38,2.69,4,5.53.89,3.83,1.54,6.47,2.11,7.53h-3.66a34.94,34.94,0,0,1-1.83-6.55c-.81-3.78-2.28-5.21-5.49-5.33H272v11.88h-3.54ZM272,101h3.62c3.79,0,6.19-2.08,6.19-5.21,0-3.54-2.57-5.09-6.31-5.13A14.12,14.12,0,0,0,272,91Z"
});

function SvgLogoCamdoctorG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 324 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCamdoctorG);
export default __webpack_public_path__ + "static/media/logo_camdoctor_g.47107995.svg";
export { ForwardRef as ReactComponent };